<template>
  <div>
    <table-button v-on="{ ...$attrs.onTooltip }" v-bind="$attrs" name="serviceIdentification" @click="onClick" />
    <popover-map v-if="coordinates" id="service-identification" :position="coordinates">
      <div
        class="popover-service tw:flexcol-2"
        :class="{ 'tw:w-(--width-nodata)': !layersData?.length, 'tw:w-(--width)': layersData?.length }"
      >
        <!-- HEADER -->
        <div class="tw:flexrow-2 tw:items-center tw:justify-between">
          <div class="tw:flexrow-1.5 tw:items-center tw:min-w-0">
            <base-button
              v-if="tab > 0 && layersData?.length > 1"
              type="text"
              icon="mdi-chevron-left"
              size="sm"
              @click="selectedDataIndex = null"
            />
            <span class="tw:font-medium tw:text-xs tw:text-left tw:truncate">
              {{ currentData?.layer?.name ?? $i18n.t('map.wmsIdentification') }}
            </span>
          </div>
          <div>
            <base-button type="text" icon="mdi-close" size="sm" @click="closePopover" />
          </div>
        </div>

        <!-- NO LAYERS INFO  -->
        <div v-if="!layersData?.length" class="tw:font-medium tw:text-gray-400 tw:text-xs tw:text-left">
          {{ $i18n.t('map.noLayersToIdentify') }}
        </div>

        <v-tabs-items v-else v-model="tab" class="tw:max-h-(--height) tw:overflow-y-auto">
          <v-tab-item>
            <!-- LAYERS LIST -->
            <div class="tw:flexcol-2">
              <v-list-item
                v-for="(data, index) in layersData"
                :key="index"
                @click="selectedDataIndex = index"
                class="tw:p-2.5 tw:bg-gray-50 tw:min-h-0 tw:rounded-base tw:before:rounded-base tw:focus:before:content-none"
              >
                <v-list-item-title class="tw:font-medium tw:text-gray-700 tw:text-xs tw:text-left">
                  {{ data.layer.name }}
                </v-list-item-title>
                <v-list-item-action class="tw:my-0">
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-tab-item>
          <v-tab-item active-class="tw:h-(--height) tw:min-h-(--height)">
            <!-- FEATURE INFO IFRAME -->
            <template v-if="currentData">
              <div
                v-if="frameStatus !== 'loaded'"
                class="tw:w-full tw:h-full tw:bg-gray-50 tw:flexcenter tw:rounded-base"
              >
                <main-loader v-if="frameStatus === 'loading'" />
                <v-icon v-else>mdi-file-remove</v-icon>
              </div>
              <iframe
                :class="{ 'tw:hidden': frameStatus !== 'loaded' }"
                :src="currentData?.infoUrl"
                @load="frameStatus = 'loaded'"
                @error="frameStatus = 'error'"
                frameborder="0"
                width="100%"
                height="100%"
              ></iframe>
            </template>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </popover-map>
  </div>
</template>

<script>
import TableButton from '@/components/TableButton';
import PopoverMap from '@/components/PopoverMap';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'TheNavbarToolsServiceIdentification',
  components: {
    TableButton,
    PopoverMap,
    MainLoader,
  },
  data: () => ({
    tab: 0,
    coordinates: null,
    layersData: null,
    selectedDataIndex: null,
    frameStatus: 'loading' /** 'loading' | 'loaded' | 'error' */,
  }),
  computed: {
    currentData() {
      return this.layersData?.[this.selectedDataIndex] ?? null;
    },
  },
  watch: {
    currentData(nV) {
      this.tab = nV ? 1 : 0;
      this.frameStatus = 'loading';
    },
  },
  methods: {
    closePopover() {
      this.coordinates = this.layersData = this.selectedDataIndex = null;
      this.frameStatus = 'loading';
    },
    onClick() {
      this.$root.$emit('serviceIdentification-action', undefined, result => {
        this.coordinates = result.position;
        this.layersData = result.data;
        this.selectedDataIndex = this.layersData.length === 1 ? 0 : null;
      });
    },
  },
};
</script>

<style scoped>
/** Popover sizing */
.popover-service {
  --height: 230px;
  --width: 300px;
  --width-nodata: 250px;
}
</style>
